import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { isValidFederalNumber } from '@fttb/common';
import { selectUserCtn } from "../../../../../store/callbackRequest/selectors";
import { setCtn, setIsCtnError } from "../../../../../store/callbackRequest/slice";
import { submitCallbackRequest } from "../../../../../store/callbackRequest/actions/submitCallbackRequest";
import { CALLBACK_CONNECTED_STATUSES, CHECK_HOUSE_CONNECTION_STATUS, EXISTS_STATUSES, popupSteps } from "../../../../../store/common/constants";
import { selectIsCheckboxChecked } from "../../../../../store/CheckboxAgreement/selectors";
import { selectPersonalVerificationCheckboxEnable } from "../../../OrderTariffFormOldPopup/store/selectors/modal";
import { setPopupVisibility } from "../../../OrderTariffFormOldPopup/store/actions/common";
import { buildOrderQueryParams, getCheckAddressStatus, getCurrentFormStep, getSelectedAddress, selectTargetTariffLink } from "../selectors";
import { resetInlineStepsData, setIsAddressErrorStatus, setIsCheckboxError, setStatus } from "../slice";
export var handleStepProgress = createAsyncThunk('handleStepProgress', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connectionData, _ref) {
    var dispatch, getState, state, isCheckboxChecked, selectedAddress, phone, isPersonalVerificationCheckboxEnable, connectionState, currentStep, userAddressData, link, newUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dispatch = _ref.dispatch, getState = _ref.getState;
          state = getState();
          isCheckboxChecked = selectIsCheckboxChecked(state);
          selectedAddress = getSelectedAddress(state);
          phone = selectUserCtn(state);
          isPersonalVerificationCheckboxEnable = selectPersonalVerificationCheckboxEnable(state);
          connectionState = getCheckAddressStatus(state);
          currentStep = getCurrentFormStep(state);
          userAddressData = buildOrderQueryParams(state);
          if (![popupSteps.shortSuccess, popupSteps.fail].includes(currentStep)) {
            _context.next = 14;
            break;
          }
          dispatch(resetInlineStepsData());
          dispatch(setCtn(''));
          dispatch(setPopupVisibility());
          return _context.abrupt("return");
        case 14:
          if (!(!selectedAddress || !selectedAddress.flat || [CHECK_HOUSE_CONNECTION_STATUS.HasConnectionOnAddress, CHECK_HOUSE_CONNECTION_STATUS.HasTicketOnAddress].includes(connectionState))) {
            _context.next = 28;
            break;
          }
          if (![].concat(_toConsumableArray(CALLBACK_CONNECTED_STATUSES), _toConsumableArray(EXISTS_STATUSES)).includes(connectionState)) {
            _context.next = 25;
            break;
          }
          if (isValidFederalNumber(phone)) {
            _context.next = 19;
            break;
          }
          dispatch(setIsCtnError(true));
          return _context.abrupt("return");
        case 19:
          if (!(!isCheckboxChecked && isPersonalVerificationCheckboxEnable)) {
            _context.next = 22;
            break;
          }
          dispatch(setIsCheckboxError(true));
          return _context.abrupt("return");
        case 22:
          _context.next = 24;
          return dispatch(submitCallbackRequest());
        case 24:
          return _context.abrupt("return");
        case 25:
          dispatch(setIsAddressErrorStatus(true));
          dispatch(setStatus(CHECK_HOUSE_CONNECTION_STATUS.CheckAddress));
          return _context.abrupt("return");
        case 28:
          link = selectTargetTariffLink(state);
          newUrl = "".concat(link, "?").concat(userAddressData);
          window.location.assign(newUrl);
        case 31:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());